import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SubscriptionService } from '../shared/services/subscription.service';

@Component({
  selector: 'app-subscription-error',
  templateUrl: './subscription-error.component.html',
  styleUrls: ['./subscription-error.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class SubscriptionErrorComponent implements OnInit {
  errorMessage: string = 'Your subscription requires attention';

  constructor(
    private subscriptionService: SubscriptionService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const message = this.subscriptionService.getSubscriptionErrorMessage();
    const status = this.subscriptionService.getSubscriptionStatus();

    if (status === 'plan_expired') {
      this.errorMessage = 'Your promotional plan has ended. Please select a new plan to continue.';
    } else if (status === 'conversion_failed') {
      this.errorMessage = 'There was an issue activating your subscription. Please select a plan and try again.';
    } else if (message) {
      this.errorMessage = message;
    }
  }

  goToLogin(): void {
    // Clear the subscription error and navigate to login
    this.subscriptionService.clearSubscriptionError();
    this.router.navigate(['/login']);
  }

  contactSupport(): void {
    // Open email client with support email
    window.location.href = 'mailto:support@aivor.co.za?subject=Subscription Issue';
  }

  renewSubscription(): void {
    // Navigate to the subscription renewal page
    this.router.navigate(['/renew-subscription']);
  }
}
